import React, { useRef, useState } from "react";

const THRESHOLD = 72;
const MAX = 108;

const TaskQueueSwipe = ({
    children,
    completeLabel = "Complete",
    altLabel = "Start",
    onComplete,
    onAlt,
}) => {
    const [x, setX] = useState(0);
    const xRef = useRef(0);
    const startRef = useRef(null);
    const axisRef = useRef(null);
    const swipedRef = useRef(false);

    const setOffset = (next) => {
        const clamped = Math.max(-MAX, Math.min(MAX, next));
        xRef.current = clamped;
        setX(clamped);
    };

    const onPointerDown = (e) => {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        startRef.current = { x: e.clientX, y: e.clientY };
        axisRef.current = null;
        swipedRef.current = false;
        e.currentTarget.setPointerCapture?.(e.pointerId);
    };

    const onPointerMove = (e) => {
        if (!startRef.current) return;
        const dx = e.clientX - startRef.current.x;
        const dy = e.clientY - startRef.current.y;
        if (!axisRef.current) {
            if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
            axisRef.current = Math.abs(dx) > Math.abs(dy) * 1.15 ? "h" : "v";
        }
        if (axisRef.current !== "h") return;
        e.preventDefault();
        setOffset(dx);
    };

    const finish = () => {
        if (!startRef.current) return;
        const dx = xRef.current;
        startRef.current = null;
        axisRef.current = null;
        if (dx >= THRESHOLD) {
            swipedRef.current = true;
            onComplete?.();
        } else if (dx <= -THRESHOLD) {
            swipedRef.current = true;
            onAlt?.();
        }
        setOffset(0);
    };

    const onClickCapture = (e) => {
        if (!swipedRef.current) return;
        e.preventDefault();
        e.stopPropagation();
        swipedRef.current = false;
    };

    return (
        <div className="task-queue__swipe">
            <div
                className={`task-queue__reveal task-queue__reveal--complete${x > 12 ? " is-on" : ""}`}
                aria-hidden
            >
                {completeLabel}
            </div>
            <div
                className={`task-queue__reveal task-queue__reveal--alt${x < -12 ? " is-on" : ""}`}
                aria-hidden
            >
                {altLabel}
            </div>
            <div
                className="task-queue__slide"
                style={{ transform: `translateX(${x}px)` }}
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={finish}
                onPointerCancel={finish}
                onClickCapture={onClickCapture}
            >
                {children}
            </div>
        </div>
    );
};

export default TaskQueueSwipe;
